export default {"src":"/apac/_next/static/media/download_fill.2fe109c6.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};